// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-w60","productName":"Table_productName__1K3Zu"};